var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border",class:( _obj = {}, _obj[("spinner-border-" + _vm.size)] = _vm.size, _obj ),attrs:{"role":"status"}},[_c('span',{staticClass:"visually-hidden",domProps:{"textContent":_vm._s('Loading...')}})])}
var staticRenderFns = []

export { render, staticRenderFns }